import { Component, OnInit, Input, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  BdcContentV2Service,
  BdcLicenseRequirementsWithValues,
  BdcSendLicenseInfoPayloadData,
} from '@tokeet-frontend/channel-content'
import { ActionFailed, isSomething, compactObject, Toaster } from '@tokeet-frontend/tv3-platform'
import { finalize, switchMap, tap } from 'rxjs/operators'
import { BdcLicensesFormComponent } from '../../bdc-licenses-form/bdc-licenses-form.component'

@Component({
  selector: 'app-bdc-property-unit-license',
  templateUrl: './bdc-property-unit-license.component.html',
})
export class BdcPropertyUnitLicenseComponent implements OnInit {
  @ViewChild('licenseForm') licenseForm: BdcLicensesFormComponent

  @Input() propertyId: number
  @Input() roomId: number

  licenses: BdcLicenseRequirementsWithValues
  isLoading = true
  isLicenseRequired = true

  constructor(private store: Store<any>, private toaster: Toaster, private contentService: BdcContentV2Service) {}

  ngOnInit(): void {
    this.load().subscribe(
      () => {},
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  load() {
    return this.contentService.getRoomLicenses(this.propertyId, this.roomId).pipe(
      finalize(() => {
        this.isLoading = false
      }),
      tap((data) => {
        this.licenses = data
        this.isLicenseRequired = isSomething(compactObject(data))
      })
    )
  }

  save() {
    const payload: BdcSendLicenseInfoPayloadData = this.licenseForm.getFormData()
    if (!payload) {
      return
    }

    this.isLoading = true
    this.contentService
      .updateRoomLicenses(this.propertyId, this.roomId, payload)
      .pipe(
        switchMap(() => this.load()),
        finalize(() => (this.isLoading = false))
      )
      .subscribe(
        () => {
          this.toaster.success($localize`Room licenses updated successfully`)
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
}
